<template>
  <div>
    <van-row>
      <van-image width="100%" :src="'http://jqcms.cloudwisdom.com.cn/storage/' + top_image" v-if="top_image"></van-image>
    </van-row>
    <van-row>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell :title="item.title" size="large" :label="item.created_at" :key="k" v-for="(item, k) of list" @click="redirectHtml(item.id)">
          <template #right-icon>
             <van-image radius="5px" width="90" height="60" :src="'http://jqcms.cloudwisdom.com.cn/storage/' + item.covers" v-if="item.covers"></van-image>
          </template>
        </van-cell>
      </van-list>
    </van-row>
  </div>
</template>

<script lang="ts">
export default {
  name: "Theme",
  data() {
    return {
      top_image: '',
      list: [ {title: '标题', created_at: '时间', covers: ''} ],
      loading: false,
      finished: false,
    }
  },
  created() {},
  methods: {
    onLoad () {
      this.$api.get('col/' + this.$route.params.id, null, (response) => {
        // console.log(response)
        this.top_image = response.col_image
        this.list = response.documents
        this.loading = false;
        if (this.list.length >= response.documents.length) {
          this.finished = true;
        }
      })
    },
    redirectHtml (id) {
      window.location.href = 'http://jqcms.cloudwisdom.com.cn/api/detail/' + id
    }
  }
};
</script>

<style scoped>
.van-cell--large {
  border-bottom: 1px solid #f2f2f2;
  padding-right: 12px;
}
.van-cell--large .van-cell__title {
  color: #000;
  line-height: 30px;
  padding-right: 15px;
}
.van-cell--large .van-cell__label {
  color: #aab2b9;
  padding-top: 5px;
}
</style>